import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-period-adjustment/:adjustmentId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    planId: string;
    adjustmentId: string;
    parkingId: string;
}
const mutationFn = ({ planId, adjustmentId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { planId, adjustmentId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeletePricingPlanAdjustment };
